import SelectRedesign from 'components/Select/SelectRedesign';
import React from 'react';
import type { OutcomeConfig } from 'types';
import { categoryTenantOverrideOptionsMap } from 'constants/models';

type ComponentProps = {
  value: OutcomeConfig['tenant_override'];
  onChange: (value: OutcomeConfig['tenant_override']) => void;
  className?: string;
  dataTestid?: string;
};

const selectOptions = Object.entries(categoryTenantOverrideOptionsMap).map(([value, label]) => ({
  label,
  value,
}));

const parseTenantOverride = (value: string): OutcomeConfig['tenant_override'] => {
  if (value === 'human' || value === 'modeler') {
    return value;
  }
  return null;
};

const CategoryTenantOverrideField: React.FC<ComponentProps> = ({
  value,
  onChange,
  className = '',
  dataTestid = 'category-tenant-override',
}) => (
  <div className={className}>
    <SelectRedesign
      dataTestid={dataTestid}
      value={value ?? ''}
      onChange={(selected): void => onChange(parseTenantOverride(selected))}
      options={selectOptions}
    />
  </div>
);

export default CategoryTenantOverrideField;
